export const OVERVIEW_BLOCK_MODAL_CONSTS = {
  addingNewBlock: 'Добавление нового блока',
  editingOfBlock: 'Редактирование блока',
  save: 'Сохранить',
  subtitle: 'Подзаголовок',
  title: 'Заголовок'
}
